export enum PaymentStep {
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  TRANSFER_DETAILS = 'TRANSFER_DETAILS',
}
